<template>
  <div>
    <img src="https://www.cyberneticsgroup.net/img/logo.png" alt="logo" width="100" />
  </div>
</template>

<script lang="ts" setup></script>
